export default {
  getMsal: function() {
    const config = {
      auth: {
        clientId: process.env.VUE_APP_clientId,
        authority: process.env.VUE_APP_tenant,
        prompt: "select_account"
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
      }
    };
    return new Msal.UserAgentApplication(config);
  },
  acquireTokenSilent: function() {
    return new Promise(resolve => {
      const loginRequest = {
        scopes: process.env.VUE_APP_scopes.split(",")
      };
      let uaa = this.getMsal();
      if (uaa.getAccount()) {
        uaa
          .acquireTokenSilent(loginRequest)
          .then(function(tokenResponse) {
            var token = tokenResponse.accessToken;
            resolve({
              token: token,
              account: tokenResponse.account
            });
          })
          .catch(function() {
            resolve(null);
          });
      } else {
        resolve(null);
      }
    });
  }
};
